module.exports = __webpack_public_path__ + "static/media/iWatch.d7c7f959.png";